import { PATIENT_PROFILE_SCROLL_KEY_PREFIX } from '@/shared/config';
import { useAppSelector, useUserTimezone } from '@/shared/hooks';

import { composedModel } from '@/entities/composed';
import { organizationModel } from '@/entities/organization';
import {
  useOpenConsultation,
  useTranscriptorConsultations,
} from '@/entities/transcriptor';

import {
  type RecordingRowActions,
  useRecordingRowActions,
} from '@/widgets/RecordingRow';

export const usePatientTimelineRecordings = (patientID: string) => {
  const userTimezone = useUserTimezone();
  const transcriptorV2Enabled = useAppSelector(
    organizationModel.selectors.selectTranscriptorV2Enabled,
  );

  const canViewArchive = useAppSelector(
    composedModel.selectors.selectCanViewPatientRecordingsArchive(patientID),
  );

  const { consultations, hiddenConsultations } = useTranscriptorConsultations(
    patientID,
    { transcriptorV2Enabled, includeHidden: canViewArchive },
  );
  const { actions, hideMode, isConsultationStale } = useRecordingRowActions();
  const openRecording = useOpenConsultation({
    patientID,
    scrollKey: `${PATIENT_PROFILE_SCROLL_KEY_PREFIX}${patientID}`,
    eventName: 'PatientProfilePageTimelineRecordingClicked',
  });

  const rowActions: RecordingRowActions = { ...actions, onOpen: openRecording };

  return {
    recordings: consultations,
    hiddenRecordings: hiddenConsultations,
    userTimezone,
    hideMode,
    isConsultationStale,
    rowActions,
  };
};
